import { render, staticRenderFns } from "./SenCommandForm.vue?vue&type=template&id=4aaf1611&scoped=true&"
import script from "./SenCommandForm.vue?vue&type=script&lang=js&"
export * from "./SenCommandForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaf1611",
  null
  
)

export default component.exports